import { render, staticRenderFns } from "./TeacherFormPreview.vue?vue&type=template&id=33154d17&scoped=true&"
import script from "./TeacherFormPreview.vue?vue&type=script&lang=js&"
export * from "./TeacherFormPreview.vue?vue&type=script&lang=js&"
import style0 from "./TeacherFormPreview.vue?vue&type=style&index=0&id=33154d17&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33154d17",
  null
  
)

export default component.exports